import type { EventName } from "@lit/react";
import { ContextMenu as ContextMenuElement, type ContextMenuEventMap as _ContextMenuEventMap, } from "@vaadin/context-menu/vaadin-context-menu.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { ContextMenuElement, };
export type ContextMenuEventMap = Readonly<{
    onClosed: EventName<_ContextMenuEventMap["closed"]>;
    onItemSelected: EventName<_ContextMenuEventMap["item-selected"]>;
    onOpenedChanged: EventName<_ContextMenuEventMap["opened-changed"]>;
}>;
const events = { onClosed: "closed", onItemSelected: "item-selected", onOpenedChanged: "opened-changed" } as ContextMenuEventMap;
export type ContextMenuProps = WebComponentProps<ContextMenuElement, ContextMenuEventMap>;
export const ContextMenu = createComponent({
    elementClass: ContextMenuElement, events, react: React, tagName: "vaadin-context-menu"
});
